import { dateFn, getTimeZoneAbbr, utcTimeToLocalTime } from '../../../utils/dateTimeFormatter';

export const SECTION_IDS = {
  address: 'order-address',
  services: 'order-services',
  preferences: 'order-preferences',
  schedule: 'order-schedule',
  payment: 'order-payment',
  summary: 'order-summary',
};

export const FREQ_OPTIONS = [
  { name: 'Weekly', value: 'WEEK' },
  { name: 'Every other week', value: 'BIWEEKLY' },
  { name: 'Monthly', value: 'MONTH' },
];

export const apiType = (orderType) => (orderType === 'oneTime' ? 'ORDER' : 'subscription');

export const pickupDateOf = (slots) => slots?.pickup_date || slots?.first_pickup_date || null;

export const hasPickup = (slots) => !!(pickupDateOf(slots) && slots?.pickup_start_time && slots?.pickup_end_time);

export const hasDropoff = (slots) => !!(slots?.dropoff_date && slots?.dropoff_start_time && slots?.dropoff_end_time);

// "Mon, Oct 12, 9 AM–11 AM" — compact form for collapsed headers.
export const shortSlot = (date, start, end, tz) =>
  date && start
    ? `${dateFn('type4', date)}, ${utcTimeToLocalTime(`${date}T${start}`, tz)}–${utcTimeToLocalTime(
        `${date}T${end}`,
        tz
      )}`
    : '';

export const formatSlot = (date, start, end, tz) =>
  date && start ? dateFn('toTZWithSeparator', date, start, end, tz) : '';

export const isOk = (res) => res?.status === 200 || res?.status === 201;

export const isAddressDisabled = (addr) => addr?.status === 'INACTIVE' || !addr?.is_address_in_active_service_area;

export const providerName = (p) =>
  p?.id ? `${p.first_name || ''} ${p.last_name?.charAt(0) || ''}.`.trim() : 'Auto-match';

export const isPickupInstructionMissing = (prefs) => {
  const choice = String(prefs?.pickup_delivery || '')
    .toLowerCase()
    .trim();
  return !choice || (choice === 'other' && String(prefs?.pickup_delivery_instructions || '').trim().length < 5);
};

export const preferencesSummary = (prefs) => {
  const parts = [prefs?.products, prefs?.wash_temp, prefs?.dryer_heat, prefs?.pickup_delivery].filter(
    (v) => v && String(v).trim() && String(v).toLowerCase() !== 'no preference'
  );
  return parts.length ? parts.join(' · ') : 'No preferences set';
};

// API schedules ({ 'YYYY-MM-DD': [{ start_time, end_time, ... }] }) -> list the UI can render.
export const toScheduleList = (schedules, tz) =>
  Object.entries(schedules || {})
    .filter(([, times]) => times?.length)
    .map(([date, times]) => ({
      key: date,
      weekday: dateFn('type7', date),
      monthDay: dateFn('type8', date),
      day: dateFn('type8', date).split(' ')[1],
      full: dateFn('type3', date),
      times: times.map((t) => ({
        start: t.start_time,
        end: t.end_time,
        label: `${utcTimeToLocalTime(`${date}T${t.start_time}`, tz)} – ${utcTimeToLocalTime(
          `${date}T${t.end_time}`,
          tz
        )}`,
        tzAbbr: getTimeZoneAbbr(`${date}T${t.start_time}`, tz),
        is_rush: !!t.is_rush,
        priority_fee: t.priority_fee,
        raw: t,
      })),
    }));

// The page scrolls inside the layout's overflow container, so scrollIntoView (not window.scrollTo).
export const OPEN_SECTION_EVENT = 'create-order:open-section';

export const scrollToSection = (id) => {
  window.dispatchEvent(new CustomEvent(OPEN_SECTION_EVENT, { detail: id }));
  // Wait a frame so a collapsed section has expanded before scrolling.
  requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
};
